import { ResultBaseModel } from './result-base-model';
import { SeatModel } from './seat-model.component';

export class SeatUpdateResultModel extends ResultBaseModel {
    failedSeats: Array<SeatModel>;
}
